import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		title: {
			textAlign: 'center',

			[theme.breakpoints.down('xs')]: {
				'& *': {
					textAlign: ({ metaData }) => {
						const alignment = metaData.mobileAlignment?.metaValue

						return alignment ? `${alignment} !important` : null
					},
				},
			},
		},

		container: {
			marginBottom: theme.spacing(4.5),
			width: '100%',
		},

		sliderContainer: {
			width: '100%',
			position: 'relative',
		},
		slider: {
			'& .slick-list': {
				margin: theme.spacing(0, -1.25),
				padding: '0 !important',

				'& .slick-slide > div': { padding: theme.spacing(0, 1.25), paddingTop: theme.spacing(0.5) },
			},

			[theme.breakpoints.down('sm')]: {
				'& .slick-list': {
					margin: theme.spacing(0, -0.625),

					'& .slick-slide': {
						'& > div': { padding: `${theme.spacing(0, 0.625)} !important` },
					},
				},
			},

			[theme.breakpoints.down('xs')]: {
				'& .slick-list': {
					overflow: 'visible',
				},
			},
		},

		control: {
			position: 'absolute',
			top: 0,
			left: 0,
			right: 0,
			paddingTop: `calc(7.15% - ${theme.spacing(0.5)} )`,
			pointerEvents: 'none',
			[theme.breakpoints.down('sm')]: {
				paddingTop: `calc(9.533% - ${theme.spacing(0.25)} )`,
			},
		},

		button: {
			position: 'absolute',
			backgroundColor: 'white',
			border: '1px solid #E5E7EB',
			borderRadius: '50%',
			width: theme.spacing(6.25),
			height: theme.spacing(6.25),
			zIndex: 2,
			bottom: 0,
			transform: 'translateY(50%)',
			pointerEvents: 'all',
		},

		leftButton: {
			left: -25,
		},
		rightButton: {
			right: -25,
		},

		icon: {
			color: 'black',
		},
	}),
	{ name: 'Video-Video6' },
)

export default useStyles
